import React, { Component, Fragment } from 'react';
import { createPortal } from 'react-dom';
import moment from 'moment';
import CategoryPinnableList from './CategoryPinnableList';
import CategoryActions from './CategoryActions';
import CategoryInfo from './CategoryInfo';
import { DynamicCaret } from '../GenericCarets';
import { addErrorMessage, addSuccessMessage } from '../../utilities/notificationUtilities';
import { getCategoryUrl } from '../../utilities/urlHelper';
import {
    isFolder,
    isSubcategory,
    isPage,
    isSuggestion,
    isExternal,
    isQuestion,
    isDocument,
    getArchivedText,
    getMovedText,
    getTotalPageCount,
    getTotalFolderCount,
    addIdToArray,
    removeIdFromArray,
    getTotalSuggestionCount,
    getTotalExternalResourceCount,
    getTotalQuestionCount,
    getTotalDocumentCount,
} from '../../utilities/categoryUtilities';

import {
    CATEGORY_ORDER_BY_DEFAULT, EVERYTHING, SUBCATEGORIES, PAGES, QUESTIONS, LINKS, REQUESTS, DOCUMENTS,
} from '../../utilities/CONSTANTS';
import MovePagesAndFolderModal from '../move/MovePagesAndFolderModal';
import ArchivePagesAndFoldersModal from '../archive/ArchivePagesAndFoldersModal';
import BulkChangePageOwnerModal from '../change/BulkChangePageOwnerModal';
import {
    archiveItemsAPI, moveItemsAPI, moveItemsToNewCategoryAPI, moveItemsToNewFolderAPI,
} from '../../api/put-bulk-action';
import { canViewSubcategoryActions } from '../../utilities/permissionsUtilities';

const SORT_ORDER = {
    NAME_ASC: 'NAME_ASC',
    NAME_DESC: 'NAME_DESC',
    MODIFIED_ASC: 'MODIFIED_ASC',
    MODIFIED_DESC: 'MODIFIED_DESC',
    DEFAULT_ASC: 'DEFAULT_ASC',
    FOLDER_DEFAULT: 'FOLDER_DEFAULT',
};

class CategoryBody extends Component {

    constructor(props) {
        super(props);
        this.state = this.getState(props);
    }

    getState = (props) => {
        const tabs = [EVERYTHING, SUBCATEGORIES, PAGES, QUESTIONS, LINKS, REQUESTS, DOCUMENTS];
        const moveMode = false;
        const archiveModal = false;
        const moveModal = false;
        const changeOwnerModal = false;
        const selectedPages = [];
        const selectedFolders = [];
        const selectedSuggestions = [];
        const selectedExternalResources = [];
        const selectedQuestions = [];
        const selectedDocuments = [];
        const selectedTab = window.tab ? tabs.includes(window.tab) ? window.tab : EVERYTHING : EVERYTHING;

        if (props.subcategory) {
            const { folderItems } = props;
            const isAuthorized = window.isAuthorized;
            const pinnedItems = folderItems.filter(item => !!item.is_pinned);
            const unPinnedItems = folderItems.filter(item => !item.is_pinned);
            const sortOrder = SORT_ORDER.FOLDER_DEFAULT;
            const sortMode = null;

            return {
                moveMode,
                selectedPages,
                selectedFolders,
                selectedSuggestions,
                selectedExternalResources,
                selectedQuestions,
                selectedDocuments,
                moveModal,
                archiveModal,
                changeOwnerModal,
                isAuthorized,
                folderItems,
                pinnedItems,
                unPinnedItems,
                sortOrder,
                sortMode,
                selectedTab,
            };
        }
        // sort order based on paginated and loading sort order
        const paginated = (window.pinnables.total > window.pinnables.per_page);
        let initialSort = SORT_ORDER.DEFAULT_ASC;
        if (paginated && window.requestSortBy) {
            const [order, direction] = window.requestSortBy.split('.');
            switch (order) {
            case 'title':
                initialSort = direction === 'asc' ? SORT_ORDER.NAME_ASC : SORT_ORDER.NAME_DESC;
                break;
            case 'modified':
                // flipped for for for caret
                initialSort = direction === 'desc' ? SORT_ORDER.MODIFIED_ASC : SORT_ORDER.MODIFIED_DESC;
                break;
            }
        }

        return ({
            moveMode,
            archiveModal,
            moveModal,
            changeOwnerModal,
            pinnablesCount: window.pinnables.total,
            pinnables: window.pinnables.data,
            paginated,
            folderItemsMap: window.folderItemsMap,
            selectedPages,
            selectedFolders,
            selectedSuggestions,
            selectedExternalResources,
            selectedQuestions,
            selectedDocuments,
            sortOrder: initialSort,
            sortMode: initialSort === SORT_ORDER.DEFAULT_ASC ? null : true,
            selectedTab,
        });

    };

    setSelectedTab = (tab) => {
        this.setState({ selectedTab: tab });
    };

    toggleMoveMode = () => {
        this.setState({ moveMode: !this.state.moveMode });
    };

    disableSortMode = () => {
        const { category, subcategory } = this.props;
        const sortMode = false;
        if (subcategory) {
            this.setState({ sortMode, sortOrder: SORT_ORDER.FOLDER_DEFAULT });
        } else {
            const { paginated } = this.state;
            if (paginated) {
                window.location.href = `${getCategoryUrl(category.id)}`;
            }
            this.setState({ sortMode, sortOrder: SORT_ORDER.DEFAULT_ASC });
        }
    };

    // logic for checking and unchecking an item something
    checkItem = (item) => {
        const { subcategory } = this.props;
        let {
            pinnables, pinnedItems, unPinnedItems, selectedPages, selectedFolders, selectedSuggestions, selectedExternalResources, selectedQuestions, selectedDocuments,
        } = this.state;

        if (isPage(item)) {
            let page;
            if (subcategory) {
                page = pinnedItems.find(page => (isPage(page) && page.id === item.id));
                if (!page) {
                    page = unPinnedItems.find(page => (isPage(page) && page.id === item.id));
                }
            } else {
                page = pinnables.find(page => (isPage(page) && page.id === item.id));
            }
            page.isChecked = !page.isChecked;
            if (page.isChecked) {
                selectedPages = addIdToArray(page.id, selectedPages);
            } else {
                selectedPages = removeIdFromArray(page.id, selectedPages);
            }
            subcategory ? this.setState({ pinnedItems, unPinnedItems, selectedPages }) : this.setState({ pinnables, selectedPages });
        } else if (isFolder(item)) {
            let folder;
            if (subcategory) {
                folder = pinnedItems.find(folder => (isFolder(folder) && folder.id === item.id));
                if (!folder) {
                    folder = unPinnedItems.find(folder => (isFolder(folder) && folder.id === item.id));
                }
            } else {
                folder = pinnables.find(folder => (isFolder(folder) && folder.id === item.id));
            }
            folder.isChecked = !folder.isChecked;
            if (folder.isChecked) {
                selectedFolders = addIdToArray(folder.id, selectedFolders);
            } else {
                selectedFolders = removeIdFromArray(folder.id, selectedFolders);
            }
            subcategory ? this.setState({ pinnedItems, unPinnedItems, selectedFolders }) : this.setState({ pinnables, selectedFolders });
        } else if (isSuggestion(item)) {
            let suggestion;
            if (subcategory) {
                suggestion = pinnedItems.find(suggestion => (isSuggestion(suggestion) && suggestion.id === item.id));
                if (!suggestion) {
                    suggestion = unPinnedItems.find(suggestion => (isSuggestion(suggestion) && suggestion.id === item.id));
                }
            } else {
                suggestion = pinnables.find(suggestion => (isSuggestion(suggestion) && suggestion.id === item.id));
            }
            suggestion.isChecked = !suggestion.isChecked;
            if (suggestion.isChecked) {
                selectedSuggestions = addIdToArray(suggestion.id, selectedSuggestions);
            } else {
                selectedSuggestions = removeIdFromArray(suggestion.id, selectedSuggestions);
            }
            subcategory ? this.setState({ pinnedItems, unPinnedItems, selectedSuggestions }) : this.setState({ pinnables, selectedSuggestions });
        } else if (isExternal(item)) {
            let external;
            if (subcategory) {
                external = pinnedItems.find(external => (isExternal(external) && external.id === item.id));
                if (!external) {
                    external = unPinnedItems.find(external => (isExternal(external) && external.id === item.id));
                }
            } else {
                external = pinnables.find(external => (isExternal(external) && external.id === item.id));
            }
            external.isChecked = !external.isChecked;
            if (external.isChecked) {
                selectedExternalResources = addIdToArray(external.id, selectedExternalResources);
            } else {
                selectedExternalResources = removeIdFromArray(external.id, selectedExternalResources);
            }
            subcategory ? this.setState({ pinnedItems, unPinnedItems, selectedExternalResources }) : this.setState({ pinnables, selectedExternalResources });
        } else if (isQuestion(item)) {
            let question;
            if (subcategory) {
                question = pinnedItems.find(question => (isQuestion(question) && question.id === item.id));
                if (!question) {
                    question = unPinnedItems.find(question => (isQuestion(question) && question.id === item.id));
                }
            } else {
                question = pinnables.find(question => (isQuestion(question) && question.id === item.id));
            }
            question.isChecked = !question.isChecked;
            if (question.isChecked) {
                selectedQuestions = addIdToArray(question.id, selectedQuestions);
            } else {
                selectedQuestions = removeIdFromArray(question.id, selectedQuestions);
            }
            subcategory ? this.setState({ pinnedItems, unPinnedItems, selectedQuestions }) : this.setState({ pinnables, selectedQuestions });
        } else if (isDocument(item)) {
            let document;
            if (subcategory) {
                document = pinnedItems.find(document => (isDocument(document) && document.id === item.id));
                if (!document) {
                    document = unPinnedItems.find(document => (isDocument(document) && document.id === item.id));
                }
            } else {
                document = pinnables.find(document => (isDocument(document) && document.id === item.id));
            }
            document.isChecked = !document.isChecked;
            if (document.isChecked) {
                selectedDocuments = addIdToArray(document.id, selectedDocuments);
            } else {
                selectedDocuments = removeIdFromArray(document.id, selectedDocuments);
            }
            subcategory ? this.setState({ pinnedItems, unPinnedItems, selectedDocuments }) : this.setState({ pinnables, selectedDocuments });
        }
    };

    toggleAll = (checked) => {
        const { subcategory } = this.props;
        let {
            pinnables, pinnedItems, unPinnedItems, selectedPages, selectedFolders, selectedSuggestions, selectedExternalResources, selectedQuestions, selectedDocuments,
        } = this.state;

        if (subcategory) {
            pinnedItems.forEach(item => {
                item.isChecked = checked;
                if (isPage(item)) {
                    selectedPages = checked ? addIdToArray(item.id, selectedPages) : removeIdFromArray(item.id, selectedPages);
                } else if (isFolder(item)) {
                    selectedFolders = checked ? addIdToArray(item.id, selectedFolders) : removeIdFromArray(item.id, selectedFolders);
                } else if (isSuggestion(item)) {
                    selectedSuggestions = checked ? addIdToArray(item.id, selectedSuggestions) : removeIdFromArray(item.id, selectedSuggestions);
                } else if (isExternal(item)) {
                    selectedExternalResources = checked ? addIdToArray(item.id, selectedExternalResources) : removeIdFromArray(item.id, selectedExternalResources);
                } else if (isQuestion(item)) {
                    selectedQuestions = checked ? addIdToArray(item.id, selectedQuestions) : removeIdFromArray(item.id, selectedQuestions);
                } else if (isDocument(item)) {
                    selectedDocuments = checked ? addIdToArray(item.id, selectedDocuments) : removeIdFromArray(item.id, selectedDocuments);
                }
            });

            unPinnedItems.forEach(item => {
                item.isChecked = checked;
                if (isPage(item)) {
                    selectedPages = checked ? addIdToArray(item.id, selectedPages) : removeIdFromArray(item.id, selectedPages);
                } else if (isFolder(item)) {
                    selectedFolders = checked ? addIdToArray(item.id, selectedFolders) : removeIdFromArray(item.id, selectedFolders);
                } else if (isSuggestion(item)) {
                    selectedSuggestions = checked ? addIdToArray(item.id, selectedSuggestions) : removeIdFromArray(item.id, selectedSuggestions);
                } else if (isExternal(item)) {
                    selectedExternalResources = checked ? addIdToArray(item.id, selectedExternalResources) : removeIdFromArray(item.id, selectedExternalResources);
                } else if (isQuestion(item)) {
                    selectedQuestions = checked ? addIdToArray(item.id, selectedQuestions) : removeIdFromArray(item.id, selectedQuestions);
                } else if (isDocument(item)) {
                    selectedDocuments = checked ? addIdToArray(item.id, selectedDocuments) : removeIdFromArray(item.id, selectedDocuments);
                }
            });

            this.setState({
                pinnedItems, unPinnedItems, selectedPages, selectedFolders, selectedSuggestions, selectedExternalResources, selectedQuestions, selectedDocuments,
            });
        } else {
            pinnables.forEach(item => {
                item.isChecked = checked;
                if (isPage(item)) {
                    selectedPages = checked ? addIdToArray(item.id, selectedPages) : removeIdFromArray(item.id, selectedPages);
                } else if (isFolder(item)) {
                    selectedFolders = checked ? addIdToArray(item.id, selectedFolders) : removeIdFromArray(item.id, selectedFolders);
                } else if (isSuggestion(item)) {
                    selectedSuggestions = checked ? addIdToArray(item.id, selectedSuggestions) : removeIdFromArray(item.id, selectedSuggestions);
                } else if (isExternal(item)) {
                    selectedExternalResources = checked ? addIdToArray(item.id, selectedExternalResources) : removeIdFromArray(item.id, selectedExternalResources);
                } else if (isQuestion(item)) {
                    selectedQuestions = checked ? addIdToArray(item.id, selectedQuestions) : removeIdFromArray(item.id, selectedQuestions);
                } else if (isDocument(item)) {
                    selectedDocuments = checked ? addIdToArray(item.id, selectedDocuments) : removeIdFromArray(item.id, selectedDocuments);
                }
            });

            this.setState({
                pinnables, selectedPages, selectedFolders, selectedSuggestions, selectedExternalResources, selectedQuestions, selectedDocuments,
            });
        }
    };

    selectAll = (e) => this.toggleAll(e.target.checked);

    typeThenModified = (a, b) => {
        if (isFolder(a) && !isFolder(b)) {
            return -1;
        }
        if (isFolder(b) && !isFolder(a)) {
            return 1;
        }
        return moment(b.updated_at).diff(moment(a.updated_at));
    };

    typeThenAlpha = (a, b) => {
        if (isFolder(a) && !isFolder(b)) {
            return -1;
        }
        if (isFolder(b) && !isFolder(a)) {
            return 1;
        }
        return a.title.localeCompare(b.title);
    };

    customSort = (a, b) => {
        const { subcategory } = this.props;
        // ranking: by rank, nulls always after a rank
        if (a.item_rank !== null && b.item_rank !== null) {
            return a.item_rank - b.item_rank;
        }
        if (a.item_rank !== null && b.item_rank === null) {
            return -1;
        }
        if (a.item_rank === null && b.item_rank !== null) {
            return 1;
        }

        if (!subcategory) {
            if (isFolder(a) && !isFolder(b)) {
                return -1;
            }
            if (isFolder(b) && !isFolder(a)) {
                return 1;
            }
        }

        return moment(b.updated_at).diff(moment(a.updated_at));
    };

    getOrderedItems = () => {
        const {
            pinnedItems, unPinnedItems, pinnables, sortOrder, sortMode, paginated,
        } = this.state;
        const { subcategory, folderItems } = this.props;

        const items = subcategory ? folderItems : pinnables;
        const defaultSortOrder = subcategory ? SORT_ORDER.FOLDER_DEFAULT : SORT_ORDER.DEFAULT_ASC;
        const orderType = subcategory ? subcategory.order_type : window.categoryOrder;

        if (!subcategory) {
            // paginated is reordered entirely on the backend
            if (paginated) {
                return pinnables;
            }
        }

        if (sortMode === null) {
            return items;
        }

        switch (sortOrder) {
        case SORT_ORDER.NAME_ASC:
            return items.sort((a, b) => (a.title.localeCompare(b.title)));
        case SORT_ORDER.NAME_DESC:
            return items.sort((a, b) => (b.title.localeCompare(a.title)));
        case SORT_ORDER.MODIFIED_ASC:
            return items.sort((a, b) => (moment(b.updated_at).diff(moment(a.updated_at))));
        case SORT_ORDER.MODIFIED_DESC:
            return items.sort((a, b) => (moment(a.updated_at).diff(moment(b.updated_at))));
        case defaultSortOrder:
            switch (orderType) {
            case CATEGORY_ORDER_BY_DEFAULT.LAST_MODIFIED:
                return items.sort((a, b) => this.typeThenModified(a, b));
            case CATEGORY_ORDER_BY_DEFAULT.ALPHABETICAL_BY_NAME:
                return items.sort((a, b) => this.typeThenAlpha(a, b));
            case CATEGORY_ORDER_BY_DEFAULT.CUSTOM:
                return items.sort((a, b) => this.customSort(a, b));
            }
        default:
            return items;
        }
    };

    clickTableHeader = (desc, asc) => {
        const { sortOrder, paginated, sortMode } = this.state;
        const { category, subcategory } = this.props;

        if (!subcategory) {
            if (paginated) {
                const selfUrl = getCategoryUrl(category.id);
                const pId = window.pinnables.current_page;

                let sort_by = '';
                let direction = '';

                let upOrDown = asc;
                if (sortOrder === asc) {
                    upOrDown = desc;
                } else {
                    upOrDown = asc;
                }

                switch (upOrDown) {
                case SORT_ORDER.NAME_ASC:
                    sort_by = 'title';
                    direction = 'asc';
                    break;
                case SORT_ORDER.NAME_DESC:
                    sort_by = 'title';
                    direction = 'desc';
                    break;
                    // flipped for for for caret
                case SORT_ORDER.MODIFIED_ASC:
                    sort_by = 'modified';
                    direction = 'desc';
                    break;
                case SORT_ORDER.MODIFIED_DESC:
                    sort_by = 'modified';
                    direction = 'asc';
                    break;
                }

                window.location.href = `${selfUrl}?sort_by=${sort_by}.${direction}&page=${pId}`;
            }
        }

        if (sortOrder === asc) {
            return this.setState({ sortOrder: desc, sortMode: true });
        }
        return this.setState({ sortOrder: asc, sortMode: true });
    };

    moveItems = (category, folder) => {
        const {
            selectedPages, selectedFolders, selectedSuggestions, selectedExternalResources, selectedQuestions, selectedDocuments,
        } = this.state;
        const { value: categoryId, label: categoryName } = category;
        const { value: folderId, label: folderName } = folder || [];

        moveItemsAPI(categoryId, folderId, selectedPages, selectedFolders, selectedSuggestions, selectedExternalResources, selectedQuestions, selectedDocuments)
            .then(({ success, categoryUrl, folderUrl }) => {
                const movedText = getMovedText(selectedPages.length, selectedFolders.length, selectedSuggestions.length, selectedExternalResources.length, selectedQuestions.length, selectedDocuments.length);

                const locationText = folderUrl
                    ? `<a href="${categoryUrl}">${categoryName}</a>` + ` / <a href="${folderUrl}">${folderName}</a>`
                    : `<a href="${categoryUrl}">${categoryName}</a>`;

                addSuccessMessage(`${movedText} to ${locationText}`);

                const { category, subcategory } = this.props;

                const cId1 = subcategory ? folderId : categoryId;
                const cId2 = subcategory ? subcategory.id : category.id;

                if (cId1 === cId2) {
                    if (subcategory) {
                        this.moveItemsAroundWindow(selectedPages, selectedFolders, selectedSuggestions, selectedExternalResources, selectedQuestions, selectedDocuments);
                    } else {
                        this.moveItemsAroundWindow(selectedPages, selectedFolders, selectedSuggestions, selectedExternalResources, selectedQuestions, selectedDocuments, folderId);
                    }
                } else {
                    this.removeItemsFromWindowAndReset(selectedPages, selectedFolders, selectedSuggestions, selectedExternalResources, selectedQuestions, selectedDocuments);
                }
            }).catch(e => {
                console.error(e);
                addErrorMessage('Error moving items and/or subcategories, please refresh page and try again.');
            });
    };

    moveItemsToNewFolder = (category, newFolder) => {
        const {
            selectedPages, selectedFolders, selectedSuggestions, selectedExternalResources, selectedQuestions, selectedDocuments,
        } = this.state;
        const { value: categoryId, label: categoryName } = category;
        const { label: newFolderName } = newFolder;

        moveItemsToNewFolderAPI(categoryId, newFolderName, selectedPages, selectedFolders, selectedSuggestions, selectedExternalResources, selectedQuestions, selectedDocuments)
            .then(({ success, categoryUrl, folderUrl }) => {
                if (success) {
                    return window.location.reload();
                }
            });
    };

    moveItemsToNewCategory = (newCategory) => {
        const {
            selectedPages, selectedFolders, selectedSuggestions, selectedExternalResources, selectedQuestions, selectedDocuments,
        } = this.state;
        const { label: newCategoryName } = newCategory;

        moveItemsToNewCategoryAPI(newCategoryName, selectedPages, selectedFolders, selectedSuggestions, selectedExternalResources, selectedQuestions, selectedDocuments)
            .then(({ success, categoryUrl }) => {
                const movedText = getMovedText(selectedPages.length, selectedFolders.length, selectedSuggestions.length, selectedExternalResources.length, selectedQuestions.length, selectedDocuments.length);
                const locationText = `<a href="${categoryUrl}">${newCategoryName}</a>`;

                addSuccessMessage(`${movedText} to ${locationText}`);
                return this.removeItemsFromWindowAndReset(selectedPages, selectedFolders, selectedSuggestions, selectedExternalResources, selectedQuestions, selectedDocuments);
            }).catch(e => {
                console.error(e);
                addErrorMessage('Error moving items and/or subcategories, please refresh page and try again.');
            });
    };

    archiveItems = () => {
        const {
            selectedPages, selectedFolders, selectedSuggestions, selectedExternalResources, selectedQuestions, selectedDocuments,
        } = this.state;
        archiveItemsAPI(selectedPages, selectedFolders, selectedSuggestions, selectedExternalResources, selectedQuestions, selectedDocuments)
            .then(({ success }) => {
                addSuccessMessage(getArchivedText(selectedPages.length, selectedFolders.length, selectedSuggestions.length, selectedExternalResources.length, selectedQuestions.length, selectedDocuments.length));
                this.removeItemsFromWindowAndReset(selectedPages, selectedFolders, selectedSuggestions, selectedExternalResources, selectedQuestions, selectedDocuments);
            }).catch(e => {
                console.error(e);
                addErrorMessage('Error archiving items and/or subcategories, please refresh page and try again.');
            });
    };

    moveItemsAroundWindow = (selectedPages, selectedFolders, selectedSuggestions, selectedExternalResources, selectedQuestions, selectedDocuments, toFolderId = null) => {
        let {
            pinnables, pinnedItems, unPinnedItems, folderItems, moveMode, archiveModal, moveModal, changeOwnerModal,
        } = this.state;
        const { subcategory } = this.props;

        let movedItems = {};

        if (subcategory) {
            pinnables = pinnedItems.concat(unPinnedItems);
        }

        pinnables = pinnables.filter(item => {
            if (isPage(item)) {
                const indexOf = selectedPages.indexOf(item.id);
                if (indexOf !== -1) {
                    selectedPages.splice(indexOf, 1);
                    movedItems[item.id] = item;
                    return false;
                }
                return true;
            } if (isFolder(item)) {
                const indexOf = selectedFolders.indexOf(item.id);
                if (indexOf !== -1) {
                    selectedFolders.splice(indexOf, 1);
                    movedItems[item.id] = item;
                    return false;
                }
                return true;
            } if (isSuggestion(item)) {
                const indexOf = selectedSuggestions.indexOf(item.id);
                if (indexOf !== -1) {
                    selectedSuggestions.splice(indexOf, 1);
                    movedItems[item.id] = item;
                    return false;
                }
                return true;
            } if (isExternal(item)) {
                const indexOf = selectedExternalResources.indexOf(item.id);
                if (indexOf !== -1) {
                    selectedExternalResources.splice(indexOf, 1);
                    movedItems[item.id] = item;
                    return false;
                }
                return true;
            } if (isQuestion(item)) {
                const indexOf = selectedQuestions.indexOf(item.id);
                if (indexOf !== -1) {
                    selectedQuestions.splice(indexOf, 1);
                    movedItems[item.id] = item;
                    return false;
                }
                return true;
            } if (isDocument(item)) {
                const indexOf = selectedDocuments.indexOf(item.id);
                if (indexOf !== -1) {
                    selectedDocuments.splice(indexOf, 1);
                    movedItems[item.id] = item;
                    return false;
                }
                return true;
            }
            return true;

        });

        if (subcategory) {
            Object.values(movedItems).forEach(item => {
                pinnables.push(item);
            });

            pinnedItems = pinnables.filter(item => !!item.is_pinned);
            unPinnedItems = pinnables.filter(item => !item.is_pinned);
        } else if (!toFolderId) {
            Object.values(movedItems).forEach(item => {
                pinnables.push(item);
            });
        }

        // note: might be nice to have a blankState() utility even w/ additional render
        selectedPages = [];
        selectedFolders = [];
        selectedSuggestions = [];
        selectedExternalResources = [];
        selectedDocuments = [];
        moveMode = false;
        archiveModal = false;
        moveModal = false;
        changeOwnerModal = false;

        if (subcategory) {
            return this.setState(
                {
                    moveMode, archiveModal, moveModal, changeOwnerModal, selectedPages, selectedFolders, selectedSuggestions, selectedExternalResources, selectedQuestions, selectedDocuments, pinnedItems, unPinnedItems, folderItems,
                },
                () => this.toggleAll(false),
            );
        }
        return this.setState(
            {
                moveMode, archiveModal, moveModal, changeOwnerModal, selectedPages, selectedFolders, selectedSuggestions, selectedExternalResources, selectedQuestions, selectedDocuments, pinnables,
            },
            () => this.toggleAll(false),
        );

    };

    removeItemsFromWindowAndReset = (selectedPages, selectedFolders, selectedSuggestions, selectedExternalResources, selectedQuestions, selectedDocuments) => {
        let {
            pinnables, pinnedItems, unPinnedItems, folderItems, moveMode, archiveModal, moveModal, changeOwnerModal,
        } = this.state;
        const { subcategory } = this.props;

        if (subcategory) {
            pinnables = pinnedItems.concat(unPinnedItems);
        }

        pinnables = pinnables.filter(item => {
            if (isFolder(item)) {
                const indexOf = selectedFolders.indexOf(item.id);
                if (indexOf !== -1) {
                    selectedFolders.splice(indexOf, 1);
                    return false;
                }
                return true;
            } if (isPage(item)) {
                const indexOf = selectedPages.indexOf(item.id);
                if (indexOf !== -1) {
                    selectedPages.splice(indexOf, 1);
                    return false;
                }
                return true;
            } if (isSuggestion(item)) {
                const indexOf = selectedSuggestions.indexOf(item.id);
                if (indexOf !== -1) {
                    selectedSuggestions.splice(indexOf, 1);
                    return false;
                }
                return true;
            } if (isExternal(item)) {
                const indexOf = selectedExternalResources.indexOf(item.id);
                if (indexOf !== -1) {
                    selectedExternalResources.splice(indexOf, 1);
                    return false;
                }
                return true;
            } if (isQuestion(item)) {
                const indexOf = selectedQuestions.indexOf(item.id);
                if (indexOf !== -1) {
                    selectedQuestions.splice(indexOf, 1);
                    return false;
                }
                return true;
            } if (isDocument(item)) {
                const indexOf = selectedDocuments.indexOf(item.id);
                if (indexOf !== -1) {
                    selectedDocuments.splice(indexOf, 1);
                    return false;
                }
                return true;
            }
        });

        if (subcategory) {
            pinnedItems = pinnables.filter(item => !!item.is_pinned);
            unPinnedItems = pinnables.filter(item => !item.is_pinned);
        }

        selectedPages = [];
        selectedFolders = [];
        selectedSuggestions = [];
        selectedExternalResources = [];
        selectedQuestions = [];
        selectedDocuments = [];
        moveMode = false;
        archiveModal = false;
        moveModal = false;
        changeOwnerModal = false;

        if (subcategory) {
            return this.setState(
                {
                    moveMode, archiveModal, moveModal, changeOwnerModal, selectedPages, selectedFolders, selectedSuggestions, selectedExternalResources, selectedQuestions, selectedDocuments, pinnedItems, unPinnedItems, folderItems,
                },
                () => this.toggleAll(false),
            );
        }
        return this.setState(
            {
                moveMode, archiveModal, moveModal, changeOwnerModal, selectedPages, selectedFolders, selectedSuggestions, selectedExternalResources, selectedQuestions, selectedDocuments, pinnables,
            },
            () => this.toggleAll(false),
        );

    };

    render() {
        const { category, subcategory } = this.props;
        const {
            moveMode, sortOrder, sortMode, pinnedItems, unPinnedItems, folderItems, paginated, pinnables, pinnablesCount, folderItemsMap, selectedPages, selectedFolders, selectedSuggestions, selectedExternalResources, selectedQuestions, selectedDocuments, changeOwnerModal,
        } = this.state;
        const totalPageCount = moveMode ? (subcategory ? getTotalPageCount(pinnedItems) + getTotalPageCount(unPinnedItems) : getTotalPageCount(pinnables)) : null;
        const totalFolderCount = moveMode ? (subcategory ? getTotalFolderCount(pinnedItems) + getTotalFolderCount(unPinnedItems) : getTotalFolderCount(pinnables)) : null;
        const totalSuggestionCount = moveMode ? (subcategory ? getTotalSuggestionCount(pinnedItems) + getTotalSuggestionCount(unPinnedItems) : getTotalSuggestionCount(pinnables)) : null;
        const totalExternalResourceCount = moveMode ? (subcategory ? getTotalExternalResourceCount(pinnedItems) + getTotalExternalResourceCount(unPinnedItems) : getTotalExternalResourceCount(pinnables)) : null;
        const totalQuestionCount = moveMode ? (subcategory ? getTotalQuestionCount(pinnedItems) + getTotalQuestionCount(unPinnedItems) : getTotalQuestionCount(pinnables)) : null;
        const totalDocumentCount = moveMode ? (subcategory ? getTotalDocumentCount(pinnedItems) + getTotalDocumentCount(unPinnedItems) : getTotalDocumentCount(pinnables)) : null;

        let orderedPinnables; let
            orderedFolderItems;

        let selectedOrderedPinnables = [];
        let everythingOrderedPinnables;
        let subcategoryOrderedPinnables;
        let pagesOrderedPinnables;
        let linksOrderedPinnables;
        let requestsOrderedPinnables;
        let questionsOrderedPinnables;
        let documentsOrderedPinnables;

        let selectedOrderedFolderItems = [];
        let everythingOrderedFolderItems;
        let subcategoryOrderedFolderItems;
        let pagesOrderedFolderItems;
        let linksOrderedFolderItems;
        let requestsOrderedFolderItems;
        let questionsOrderedFolderItems;
        let documentsOrderedFolderItems;

        if (subcategory) {
            orderedFolderItems = this.getOrderedItems();

            everythingOrderedFolderItems = orderedFolderItems;
            subcategoryOrderedFolderItems = orderedFolderItems.filter(pinnables => isSubcategory(pinnables));
            pagesOrderedFolderItems = orderedFolderItems.filter(pinnables => isPage(pinnables));
            linksOrderedFolderItems = orderedFolderItems.filter(pinnables => isExternal(pinnables));
            requestsOrderedFolderItems = orderedFolderItems.filter(pinnables => isSuggestion(pinnables));
            questionsOrderedFolderItems = orderedFolderItems.filter(pinnables => isQuestion(pinnables));
            documentsOrderedFolderItems = orderedFolderItems.filter(pinnables => isDocument(pinnables));

            if (this.state.selectedTab === EVERYTHING) {
                selectedOrderedFolderItems = everythingOrderedFolderItems;
            }

            if (this.state.selectedTab === SUBCATEGORIES) {
                selectedOrderedFolderItems = subcategoryOrderedFolderItems;
            }

            if (this.state.selectedTab === PAGES) {
                selectedOrderedFolderItems = pagesOrderedFolderItems;
            }

            if (this.state.selectedTab === LINKS) {
                selectedOrderedFolderItems = linksOrderedFolderItems;
            }

            if (this.state.selectedTab === REQUESTS) {
                selectedOrderedFolderItems = requestsOrderedFolderItems;
            }

            if (this.state.selectedTab === QUESTIONS) {
                selectedOrderedFolderItems = questionsOrderedFolderItems;
            }

            if (this.state.selectedTab === DOCUMENTS) {
                selectedOrderedFolderItems = documentsOrderedFolderItems;
            }
        } else {
            orderedPinnables = this.getOrderedItems();

            everythingOrderedPinnables = orderedPinnables;
            subcategoryOrderedPinnables = orderedPinnables.filter(pinnables => isSubcategory(pinnables));
            pagesOrderedPinnables = orderedPinnables.filter(pinnables => isPage(pinnables));
            linksOrderedPinnables = orderedPinnables.filter(pinnables => isExternal(pinnables));
            requestsOrderedPinnables = orderedPinnables.filter(pinnables => isSuggestion(pinnables));
            questionsOrderedPinnables = orderedPinnables.filter(pinnables => isQuestion(pinnables));
            documentsOrderedPinnables = orderedPinnables.filter(pinnables => isDocument(pinnables));

            if (this.state.selectedTab === EVERYTHING) {
                selectedOrderedPinnables = everythingOrderedPinnables;

            }

            if (this.state.selectedTab === SUBCATEGORIES) {
                selectedOrderedPinnables = subcategoryOrderedPinnables;
            }

            if (this.state.selectedTab === PAGES) {
                selectedOrderedPinnables = pagesOrderedPinnables;
            }

            if (this.state.selectedTab === LINKS) {
                selectedOrderedPinnables = linksOrderedPinnables;
            }

            if (this.state.selectedTab === REQUESTS) {
                selectedOrderedPinnables = requestsOrderedPinnables;
            }

            if (this.state.selectedTab === QUESTIONS) {
                selectedOrderedPinnables = questionsOrderedPinnables;
            }

            if (this.state.selectedTab === DOCUMENTS) {
                selectedOrderedPinnables = documentsOrderedPinnables;
            }
        }

        const tableHeader = (
            <thead>
                <tr>
                    <th
                        className="th__sortable left-corner"
                        onClick={() => this.clickTableHeader(SORT_ORDER.NAME_DESC, SORT_ORDER.NAME_ASC)}
                    >
                    Name
                        <DynamicCaret
                            caretUp={SORT_ORDER.NAME_ASC}
                            caretDown={SORT_ORDER.NAME_DESC}
                            currentSortOrder={sortOrder}
                        />
                    </th>
                    <th
                        className="th__sortable sm-show-table-cell"
                        onClick={() => this.clickTableHeader(SORT_ORDER.MODIFIED_DESC, SORT_ORDER.MODIFIED_ASC)}
                    >
                    Last modified
                        <DynamicCaret
                            caretUp={SORT_ORDER.MODIFIED_DESC}
                            caretDown={SORT_ORDER.MODIFIED_ASC}
                            currentSortOrder={sortOrder}
                        />
                    </th>
                    <th className="center sm-show-table-cell">Owner</th>
                    <th className="th__actions" />
                </tr>
            </thead>
        );

        const archivePagesAndFoldersModal = (
            <ArchivePagesAndFoldersModal
                pagesCount={selectedPages.length}
                foldersCount={selectedFolders.length}
                suggestionsCount={selectedSuggestions.length}
                externalResourcesCount={selectedExternalResources.length}
                questionsCount={selectedQuestions.length}
                documentsCount={selectedDocuments.length}
                closeModal={() => this.setState({ archiveModal: false })}
                handleArchive={this.archiveItems}
            />
        );

        const showCategoryPinnableList = subcategory ? true : (orderedPinnables && folderItemsMap);

        return (
            <Fragment>
                <div className="mb2 flex">
                    <div className="tab-nav flex-auto">
                        <CategoryInfo
                            everythingTabNavCount={subcategory ? everythingOrderedFolderItems.length : everythingOrderedPinnables.length}
                            subcategoryTabNavCount={subcategory ? subcategoryOrderedFolderItems.length : subcategoryOrderedPinnables.length}
                            pagesTabNavCount={subcategory ? pagesOrderedFolderItems.length : pagesOrderedPinnables.length}
                            linksTabNavCount={subcategory ? linksOrderedFolderItems.length : linksOrderedPinnables.length}
                            documentsTabNavCount={subcategory ? documentsOrderedFolderItems.length : documentsOrderedPinnables.length}
                            requestsTabNavCount={subcategory ? requestsOrderedFolderItems.length : requestsOrderedPinnables.length}
                            moveMode={moveMode}
                            sortMode={sortMode}
                            disableSortMode={this.disableSortMode}
                            totalPageCount={totalPageCount}
                            totalFolderCount={totalFolderCount}
                            totalSuggestionCount={totalSuggestionCount}
                            totalExternalResourceCount={totalExternalResourceCount}
                            totalQuestionCount={totalQuestionCount}
                            totalDocumentCount={totalDocumentCount}
                            selectedPageCount={selectedPages.length}
                            selectedFoldersCount={selectedFolders.length}
                            selectedSuggestionCount={selectedSuggestions.length}
                            selectedExternalResourceCount={selectedExternalResources.length}
                            selectedQuestionsCount={selectedQuestions.length}
                            selectedDocumentsCount={selectedDocuments.length}
                            selectAll={this.selectAll}
                            moveItems={() => this.setState({ moveModal: true })}
                            archiveItems={() => this.setState({ archiveModal: true })}
                            changeOwner={() => this.setState({ changeOwnerModal: true })}
                            count={subcategory ? (pinnedItems.length + unPinnedItems.length) : pinnables.length}
                            selectedTab={this.state.selectedTab}
                            handleSetSelectedTab={(tab) => this.setSelectedTab(tab)}
                            questionsCount={subcategory ? questionsOrderedFolderItems.length : questionsOrderedPinnables.length}
                        />
                    </div>
                    <div className="flex-none">
                        {canViewSubcategoryActions() && <CategoryActions {...this.props} toggleMoveMode={this.toggleMoveMode} moveMove={moveMode} />}
                    </div>
                </div>
                <div className="responsive-page-list-container">
                    <table className="page-list">
                        {tableHeader}
                        {showCategoryPinnableList
                            && (
                                <CategoryPinnableList
                                    {...this.props}
                                    checkItem={this.checkItem}
                                    moveMode={moveMode}
                                    categoryItems={subcategory ? selectedOrderedFolderItems : selectedOrderedPinnables}
                                    sortOrder={sortOrder}
                                    folderItemsMap={folderItemsMap}
                                    isAuthorized={window.isAuthorized}
                                    selectedTab={this.state.selectedTab}
                                />
                            )}
                        {this.state.archiveModal
                            && createPortal(archivePagesAndFoldersModal, document.body)}
                        {this.state.moveModal
                            && createPortal(<MovePagesAndFolderModal
                                categoryId={subcategory ? subcategory.category_id : category.id}
                                subcategoryId={subcategory ? subcategory.id : null}
                                pagesCount={selectedPages.length}
                                foldersCount={selectedFolders.length}
                                selectedFolders={selectedFolders}
                                suggestionsCount={selectedSuggestions.length}
                                externalResourcesCount={selectedExternalResources.length}
                                questionsCount={selectedQuestions.length}
                                documentsCount={selectedDocuments.length}
                                closeModal={() => this.setState({ moveModal: false })}
                                handleMove={this.moveItems}
                                handleMoveToNewFolder={this.moveItemsToNewFolder}
                                handleMoveToNewCategory={this.moveItemsToNewCategory}
                            />, document.body)}
                        {this.state.changeOwnerModal
                            && createPortal(
                                <BulkChangePageOwnerModal
                                    closeModal={() => this.setState({ changeOwnerModal: false })}
                                    resetMultiSelect={() => {
                                        this.toggleAll(false);
                                        this.toggleMoveMode();
                                    }}
                                    selectedPages={selectedPages}
                                />,
                                document.body,
                            )}
                    </table>
                </div>
            </Fragment>
        );
    }
}

export default CategoryBody;
